import { useStore } from '@nanostores/react';
import type React from 'react';
import { Logo } from '~/components/ui/Logo';
import { chatStore } from '~/lib/stores/chat';
import { classNames } from '~/utils/classNames';

interface BaseHeaderProps {
  border?: boolean;
  logoChildren?: React.ReactNode;
  children?: React.ReactNode;
}

export function BaseHeader({ border, logoChildren, children }: BaseHeaderProps) {
  const chatStarted = useStore(chatStore.started);
  return (
    <header
      className={classNames(
        'flex shrink-0 select-none selection-accent items-center pl-5 pr-4 border-b h-[var(--header-height)]',
        {
          'z-21 border-transparent fixed w-full backdrop-blur-[17px]': !chatStarted,
          'border-bolt-elements-borderColor': border,
          'border-transparent': !border,
        },
      )}
    >
      <div className="flex grow-1 basis-60 items-center gap-2 text-bolt-elements-textPrimary">
        <div className="z-logo">
          <Logo />
        </div>
        {logoChildren}
      </div>
      {children}
    </header>
  );
}
